import type { SpaceGroup } from "@circle-react/types/SpaceGroup";
import { useMemo, useState } from "react";
import { keepPreviousData } from "react-query";

import {
  SORT_OPTIONS_MAP,
  useCommunityMembersInfiniteQuery,
  type CommunityMembersFilter,
} from "@/react/hooks/useCommunityMembersInfiniteQueryV2";
import { useIsFeatureFlagEnabled } from "@/react/hooks/UseCommunitySetting";

const MEMBERS_TAB_PER_PAGE = 20;

export const useSpaceGroupMembersTabData = (spaceGroup: SpaceGroup) => {
  const [query, setQuery] = useState("");

  const filters = useMemo<CommunityMembersFilter[]>(() => {
    const nextFilters: CommunityMembersFilter[] = [
      { key: "space_groups", value: spaceGroup.slug },
    ];

    if (query) {
      nextFilters.push({
        key: "name_and_email",
        value: query,
        filter_type: "contains",
      });
    }

    return nextFilters;
  }, [query, spaceGroup.slug]);

  const isClickHouseSearchEnabled = useIsFeatureFlagEnabled(
    "crm_clickhouse_space_members_search_enabled",
  );
  const infiniteQuery = useCommunityMembersInfiniteQuery({
    filters,
    sort: SORT_OPTIONS_MAP.ROLE,
    perPage: MEMBERS_TAB_PER_PAGE,
    isClickHouseSearchEnabled,
    options: {
      placeholderData: keepPreviousData,
    },
  });

  return {
    infiniteQuery,
    query,
    setQuery,
  };
};
